// /*
//   PLEASE DON'T EDIT THIS FILE.
//   IF YOU NEED TO OVERRIDE IT,
//   DO IT IN THE COMPONENT.
// */

// PARTIAL. IT WOULD BE GOOD TO ADD OTHER BUTtON ACTIONS

export const onActionButtonFirstItemClick = (
  data,
  actionButtonsConfig,
  createButtonMode,
  mfGridComponentRef,
  history
) => {
  if (data && data.url) {
    history.push(data.url)
  } else if (actionButtonsConfig.actionButtonsMode === 'oneActionButtonOnly') {
    console.info('First (or only) action button clicked')
  } else if (
    createButtonMode === 'inline' &&
    (actionButtonsConfig.actionButtonsMode === 'createButtonOnly' || 'createButtonAndActionButtons')
  ) {
    mfGridComponentRef.current.instance.addRow()
  } else {
    console.warn('No data found in the clicked action button.')
  }
}

export const onActionButtonAnyItemClick = (data, history) => {
  if (data.itemData && data.itemData.url) {
    history.push(data.itemData.url)
  } else if (data.itemData) {
    console.info(`Action button from list clicked. \nId: ${data.itemData.id} \nLabel: ${data.itemData.text}`)
  } else {
    console.warn('No itemData found in the clicked action button.')
  }
}
